export default "__VITE_ASSET__D_8Ywb8u__"